import { useState } from 'react';
import { useForm } from 'react-hook-form';
import GridCard from './GridCard';
import APIS from '../../constant/EndPoint';
import DataTable from '../Reusable/DataTable';
import moment from 'moment';
import { classNames } from '../../utils/classNames';
import NACell from '../Reusable/DataTable/NACell';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import Card from '../Reusable/Card';
import DateRangePicker from '../Reusable/DateRangePicker';
import StatusCard from './StatusCard';
import ComboboxInput from '../Reusable/ComboboxInput';
//@ts-ignore
import { AccessControl } from '@careinfo/merchant-permission-service';
import useGetHook from '../../customHooks/useGetHook';
const Overview = (props: any) => {
  const { gridData, setSelectedItem, draftOrder, isLoading, handleClearCache } =
    props;
  const {
    register,
    setValue,
    getValues,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm<any>();
  const [cardFilterParms, setCardFilterParms] = useState<any>({});
  const [activeCard, setActiveCard] = useState('');
  const [date, setDate] = useState('');
  let defaultColumns: any = [
    {
      header: 'WayBill',
      accessorKey: 'tracking_number',
      cell: ({ row, getValue }: any) => {
        return (
          <div onClick={() => {}} className={'cursor-pointer'}>
            <p
              className={classNames(
                row?.original?.is_duplicate ? 'text-red-600' : '',
                'whitespace-nowrap'
              )}
            >
              {getValue() ?? 'N/A'}
            </p>
            <p className='text-xs text-gray-500'>
              {moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}
            </p>
          </div>
        );
      },
    },
    {
      header: 'Ref No.',
      accessorKey: 'reference_number',
      cell: NACell,
    },
    {
      header: 'Destination',
      accessorKey: 'destination.name',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className={tw`uppercase`}>{getValue()}</p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.destination_branch?.warehouse?.name}
            </p>
          </>
        );
      },
    },
    {
      header: 'Receiver',
      accessorKey: 'receiver.full_name',
      cell: NACell,
    },
    {
      header: 'Piece',
      accessorKey: 'piece',
      cell: NACell,
    },
    {
      header: 'Weight',
      accessorKey: 'weight',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()}
              <span className='text-gray-500 text-xs'>Kgs</span>{' '}
            </p>
          </>
        );
      },
    },
    {
      header: 'Remarks',
      accessorKey: 'remark',
      cell: ({ row, getValue }: any) => <p> {getValue()} Remarks</p>,
    },
    {
      header: 'Status',
      accessorKey: 'delivery_status.name',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{ background: row?.original?.delivery_status?.color }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary `}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
  ];
  const handleOnClickGrid = (key: string, name: string) => {
    setCardFilterParms(key);
    setActiveCard(name);
  };

  const filterParams = watch();
  const {
    data: statusData,
    isLoading: isStatusLoading,
    isRefetching,
  } = useGetHook({
    queryKey: ['status', `${JSON.stringify(filterParams)}-${date}`],
    url: `${APIS.STATUS}overview/`,
    params: {
      is_active: true,
      date_range: date,
      ...filterParams,
    },
  });

  return (
    <>
      <AccessControl
        children={
          <Card>
            <div className={tw` p-2 grid grid-cols-3 gap-x-2`}>
              <DateRangePicker
                label={'Select Date Range'}
                setValue={setValue}
                name={'created__range'}
                getValues={getValues}
                setDate={setDate}
              />
              <ComboboxInput
                url={APIS.BRANCH}
                queryKey={'barnch'}
                register={register('pickup_branch')}
                errors={errors?.pickup_branch}
                name={'pickup_branch'}
                label={'Pickup Branch'}
                props={{ is_active: true }}
                setValue={setValue}
                placeholder={'Select Pickup Branch'}
                getValues={getValues}
                clearErrors={clearErrors}
              />
              <ComboboxInput
                url={APIS.LOCATION}
                props={{ level: 3, is_active: true }}
                queryKey={'city'}
                register={register('destination')}
                errors={errors?.destination}
                name={'destination'}
                label={'Select Destination City'}
                setValue={setValue}
                placeholder={'Select Destination City'}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
          </Card>
        }
        allowedPermissions={['can_edit_merchant_overview_filter']}
      />
      <div className={tw`flex justify-end`}>
        <button
          type='button'
          disabled={isLoading || false}
          onClick={() => handleClearCache()}
          className={tw`text-primary  font-semibold mb-2 mr-2 focus:outline-none`}
        >
          Refresh
        </button>
      </div>
      <div className={tw`grid grid-cols-3 gap-x-8 `}>
        {gridData?.map((item: any, index: number) => (
          <GridCard
            key={index}
            item={item}
            onClick={handleOnClickGrid}
            props={{ ...getValues() }}
            selectedCardItems={cardFilterParms}
            activeCard={activeCard}
          />
        ))}
      </div>
      <div className={tw`text-lg font-bold text-primary pb-4 px-2`}>
        Status Card
      </div>
      {!isStatusLoading && Array.isArray(statusData) && !isRefetching ? (
        <div className={tw`grid grid-cols-4 gap-x-8 `}>
          {statusData?.map((item: any, index: number) => (
            <StatusCard
              key={index}
              item={item}
              onClick={handleOnClickGrid}
              props={{ ...getValues() }}
              selectedCardItems={cardFilterParms}
              activeCard={activeCard}
            />
          ))}
        </div>
      ) : (
        <div className={tw`grid grid-cols-4 gap-x-6  `}>
          {Array.from({ length: 8 }).map((_, index) => {
            return (
              <div
                key={index}
                className={tw`w-full bg-gray-200 rounded-md h-20  mb-8 animate-pulse`}
                style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
              ></div>
            );
          })}
        </div>
      )}
      <div>
        <DataTable
          url={APIS.ORDER}
          queryKey={'orders'}
          columns={defaultColumns}
          addNewPagePath={''}
          tableName={'Order'}
          actionMenu={
            <>
              {draftOrder?.count ? (
                <div
                  className={tw`flex w-full justify-end items-center text-lg font-bold`}
                >
                  <div
                    onClick={() =>
                      window.location.replace(`/pickup-request#/create`)
                    }
                  >
                    Draft Orders &#58; {draftOrder?.count}
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          }
          params={{
            ...filterParams,
            is_rtv: filterParams?.is_rtv ? true : null,
            order_remarks__isnull: filterParams?.order_remarks__isnull
              ? false
              : null,
            is_draft: false,
            is_walking_customer: filterParams?.is_walking_customer
              ? true
              : null,
            delivery_status__in: cardFilterParms,
          }}
        />
      </div>
    </>
  );
};

export default Overview;
